import type { DeliveryUrgency } from './types';

/** Id фразы героя на маркере карты (GDD v2 § срочность заказа). */
export type DeliveryGiantMessageId =
  | 'regular'
  | 'important_day1'
  | 'important_day2_plus'
  | 'urgent_day1'
  | 'urgent_day2'
  | 'urgent_day3_plus';

export function deliveryGiantMessageId(
  urgency: DeliveryUrgency,
  waitingDay: number,
): DeliveryGiantMessageId {
  const day = Math.max(1, Math.floor(waitingDay));
  switch (urgency) {
    case 'regular':
      return 'regular';
    case 'important':
      return day === 1 ? 'important_day1' : 'important_day2_plus';
    case 'urgent':
      if (day === 1) {
        return 'urgent_day1';
      }
      if (day === 2) {
        return 'urgent_day2';
      }
      return 'urgent_day3_plus';
    default:
      return 'regular';
  }
}

export function deliveryGiantMessageI18nKey(id: DeliveryGiantMessageId): string {
  return `game.map.giantMessage.${id}`;
}
